import { render } from "./Version.vue?vue&type=template&id=4a59a1cd&scoped=true&ts=true"
import script from "./Version.vue?vue&type=script&lang=ts"
export * from "./Version.vue?vue&type=script&lang=ts"

import "./Version.vue?vue&type=style&index=0&id=4a59a1cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a59a1cd"]])

export default __exports__